import {environment} from "../../env";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import {Bag} from "../../services/classes/Bag";
import {SelectProps} from "@mui/material/Select/Select";
import Select from "@mui/material/Select";
import {AdminPanelSettings, VisibilityOff} from "@mui/icons-material";
import {useStores} from "../../stores";

type Props = SelectProps & {
    bags: Bag[]
};
export const SelectDatasetMenu: React.FC<Props> = ({bags, ...selectProps}) => {
    const {authStore} = useStores();
    return <Select {...selectProps}>
        {(!(environment.isTest || authStore.isMithraStaffGroup))
            // https://github.com/mui/material-ui/issues/16181
            ? [[
                bags.filter(b => !b.hidden)
                    .map(bag => <MenuItem key={bag.id} value={bag.id}>{bag.name}</MenuItem>
                    )
            ]] : [[
                bags.map(bag =>
                    <MenuItem key={bag.id} value={bag.id}><ShowDebugDataset bag={bag}/></MenuItem>
                )
            ]]
        }
    </Select>;
}

export const ShowDebugDataset: React.FC<{bag: Bag}> = ({bag}) =>
    <>
        {bag.hidden ? <><AdminPanelSettings/><VisibilityOff/> </> : null}
        [{bag.id}] {bag.name}
    </>
